import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import TestimonialForm from "../components/TestimonialForm";
import TestimonialsSection from "../components/TestimonialsSection";

export default function Testimonios() {
  return (
    <div data-testid="testimonios-page" className="min-h-screen">
      <Navbar />
      <section className="pt-24 max-w-2xl mx-auto px-6">
        <TestimonialForm />
      </section>
      <TestimonialsSection />
      <Footer />
    </div>
  );
}
